module.exports = __webpack_public_path__ + "static/media/Promotional_Graphic@3x.7adb8676.png";